module.exports={
	"Form": "LabViewManifest",
	"Scope": "Lab-View",
	"Descriptors":
	{
		"LabDetails.Name":
		{
			"Name": "Name",
			"Hash": "Lab-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "Lab-View-Identity",
				"Group": "Lab-View-Identity"
			}
		},
		"LabDetails.IDOrganization":
		{
			"Name": "Organization",
			"Hash": "Lab-View-IDOrganization",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "Lab-View-Details",
				"Group": "Lab-View-Details",
				"Entity": "Organization",
				"SearchFields":
				[
					"Name",
					"VendorCode",
					"FederalTaxCode"
				],
				"ReadOnly": true
			}
		},
		"LabDetails.IDOrganizationAddress":
		{
			"Name": "Organization Address",
			"Hash": "Lab-View-IDOrganizationAddress",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "Lab-View-Details",
				"Group": "Lab-View-Details",
				"Entity": "OrganizationAddress",
				"SearchFields":
				[
					"LocationName"
				],
				"ReadOnly": true
			}
		},
		"LabDetails.ExternalOrganization":
		{
			"Name": "External Organization",
			"Hash": "Lab-View-ExternalOrganization",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "2",
				"Width": 3,
				"Section": "Lab-View-Details",
				"Group": "Lab-View-Details"
			}
		},
		"LabDetails.Notes":
		{
			"Name": "Notes",
			"Hash": "Lab-View-Notes",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 12,
				"Section": "Lab-View-Details",
				"Group": "Lab-View-Details"
			}
		},
		"LabDetails.IDLabParent":
		{
			"Name": "Parent Lab",
			"Hash": "Lab-View-IDLabParent",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "Lab-View-Details",
				"Group": "Lab-View-Details",
				"Entity": "Lab",
				"SearchFields":
				[
					"Name"
				],
				"ReadOnly": true
			}
		},
		"LabDetails.ExternalLabID":
		{
			"Name": "External Lab ID",
			"Hash": "Lab-View-ExternalLabID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "Lab-View-Details",
				"Group": "Lab-View-Details"
			}
		},
		"LabDetails.BypassReceived":
		{
			"Name": "Bypass Received",
			"Hash": "Lab-View-BypassReceived",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "Lab-View-Details",
				"Group": "Lab-View-Details"
			}
		},
		"LabDetails.AggregateTo":
		{
			"Name": "Aggregate To",
			"Hash": "Lab-View-AggregateTo",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "5",
				"Width": 3,
				"Section": "Lab-View-Details",
				"Group": "Lab-View-Details"
			}
		},
		"LabDetails.IDLab":
		{
			"Name": "IDLab",
			"Hash": "Lab-View-IDLab",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Lab-View-DataAudit",
				"Group": "Lab-View-DataAudit"
			}
		},
		"LabDetails.GUIDLab":
		{
			"Name": "GUIDLab",
			"Hash": "Lab-View-GUIDLab",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Lab-View-DataAudit",
				"Group": "Lab-View-DataAudit"
			}
		},
		"LabDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "Lab-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Lab-View-DataAudit",
				"Group": "Lab-View-DataAudit"
			}
		},
		"LabDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "Lab-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Lab-View-DataAudit",
				"Group": "Lab-View-DataAudit"
			}
		},
		"LabDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "Lab-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Lab-View-DataAudit",
				"Group": "Lab-View-DataAudit"
			}
		},
		"LabDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "Lab-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Lab-View-DataAudit",
				"Group": "Lab-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Lab-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Lab-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Lab-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Lab-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "Lab-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "Lab-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
